import { RequestService } from 'angular/resources/request.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { RestResourceModule } from 'angular/resources/rest-resource.module';

@Injectable({
    providedIn: RestResourceModule
})
export class FeaturePackGroupResource {
    private readonly restUrl = 'feature-pack-group';

    constructor(private requestService: RequestService) {}

    public get(id: number): Observable<FeaturePackGroupDto> {
        return this.requestService.get<FeaturePackGroupDto>(
            this.restUrl + `/${id}`
        );
    }
}
